import { useLocation } from "react-router-dom";
import { Search } from "lucide-react";
import { ADMIN_CRUMBS } from "@/lib/adminNavigation";

export default function TopHeader({ onOpenPalette }) {
  const location = useLocation();

  let title = ADMIN_CRUMBS[location.pathname];
  if (!title) {
    if (location.pathname.startsWith("/danisanlar/")) title = "Danışan Detayı";
    else title = "";
  }

  return (
    <header
      className="h-14 border-b border-pleiades-border bg-white/95 backdrop-blur-sm px-4 flex items-center justify-between shrink-0"
      data-testid="top-header"
    >
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-[12px] uppercase tracking-wider text-pleiades-muted">
          Pleiades Rehberlik
        </span>
        <span className="text-pleiades-muted">/</span>
        <h1 className="text-[14px] font-medium text-pleiades-ink truncate" data-testid="page-title">
          {title}
        </h1>
      </div>

      <button
        onClick={onOpenPalette}
        data-testid="btn-open-cmd"
        className="hidden sm:flex items-center gap-2 h-8 pl-2.5 pr-2 border border-pleiades-border rounded-sm text-[12px] text-pleiades-slate hover:border-pleiades-border-strong hover:text-pleiades-ink transition-colors bg-white min-w-[220px]"
      >
        <Search className="w-3.5 h-3.5" strokeWidth={1.6} />
        <span className="flex-1 text-left">Ara veya git…</span>
        <kbd className="hidden md:inline text-[10px] font-mono border border-pleiades-border px-1 py-0.5 rounded-sm text-pleiades-muted">
          ⌘K
        </kbd>
      </button>
    </header>
  );
}
